// extracted by mini-css-extract-plugin
module.exports = {"popup":"styles__popup___2uTq2"};